// extracted by mini-css-extract-plugin
module.exports = {"modulos":"Modulos_modulos__kqVgd","botaoVoltar":"Modulos_botaoVoltar__JuJkj"};